exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo-gallery .logo-card[data-v-adcb6de8]{height:260px;cursor:pointer;width:200px}.logo-gallery .logo-card_logo[data-v-adcb6de8]{height:200px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:start;justify-content:start}.logo-gallery .logo-card_logo__image[data-v-adcb6de8]{height:100%;max-width:100%;object-fit:cover}.logo-gallery .logo-card_info[data-v-adcb6de8]{font-weight:700;font-size:1rem;height:65px;padding:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-adcb6de8","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/uikit/components/AppDefaultLayout/components/sections/logo/Logos.vue
// module id = ae0a019766a1e6e7b51c
// module chunks = 0